import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider, UserInfoContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { AdminControl as AdminControlPage } from '../Components/Organisms/AdminControl/AdminControl'

@Route(RouteID.ADMIN_CONTROL)
export class AdminControl extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.ADMIN_CONTROL}>
                <UserInfoContextProvider>
                    <LanguageContextProvider>
                        <AdminControlPage />
                    </LanguageContextProvider>
                </UserInfoContextProvider>
            </RouteGuard>
        )
    }
}
